import React, { useMemo } from 'react';
import { css } from '@emotion/core';
import { Typography } from '@material-ui/core';

/**
 * ProgressDots 組件 - 顯示動態載入文字
 * @param {Object} props
 * @param {string} [props.text='Loading...'] - 要顯示的文字
 * @param {number} [props.delay=100] - 延遲時間
 * @param {Object} [props.cusStyle] - 自定義樣式
 * @returns {JSX.Element}
 */
const WaveAnimationText = ({ text = '', delay = 100, color, cusStyle }) => {
    const textArray = useMemo(() => {
        try {
            const textArray = text.split('');
            return textArray;
        } catch (e) {
            return [];
        }
    }, [text]);

    return Boolean(text) ? (
        <div css={[containerStyle(color), waveAnimation, cusStyle]}>
            {textArray.map((char, index) => (
                <Typography key={index} css={[textStyle(index * delay)]} variant="h6">
                    {char === ' ' ? '\u00A0' : char}
                </Typography>
            ))}
        </div>
    ) : null;
};

export default WaveAnimationText;

const containerStyle = color => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    color: ${color};
`;

const textStyle = delayMS => css`
    animation: wave 2s ease infinite;
    animation-delay: ${delayMS}ms;
    display: inline-block;
    line-height: 130%;
`;

const waveAnimation = css`
    @keyframes wave {
        0%,
        40%,
        100% {
            transform: translate(0, 0);
        }
        10% {
            transform: translate(0, -15px);
        }
    }
`;
